import React from 'react';
import { HeadingText, ParagraphText } from '@leagueplatform/genesis-core';
import { EmptyStateCard } from '../empty-state-card/empty-state-card.component';

export const EmptyEntityListCard = ({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) => (
  <EmptyStateCard>
    <HeadingText size="lg" level="2">
      {heading}
    </HeadingText>
    <ParagraphText>{description}</ParagraphText>
  </EmptyStateCard>
);
